<template>
    <div class="w-full">
    <!-- Mobile progress bar -->
    <div class="w-full md:hidden mt-6 mb-20 px-0 flex items-center">
        <div class="w-full rounded-full bg-orange-100 h-1.5 flex items-center">
            <div
                class="h-1.5 rounded-full bg-[#FD421D] transition-all"
                :style="{ width: progressPercent + '%' }"
            ></div>
        </div>
    </div>

    <!-- Desktop progress bar with back button -->
    <div
        class="w-full hidden md:flex items-center justify-between mb-0"
    >
        <div class="min-w-[60px]">
            <button
                v-if="step > 0"
                type="button"
                @click="$emit('back')"
                class="inline-flex items-center gap-2 rounded text-slate-600 text-sm font-medium"
            >
                <Icon icon="chevron-left-small" />
                <span class="hidden md:inline">Back</span>
            </button>
        </div>
        <div class="flex-1 hidden md:flex justify-center">
            <div class="w-[175px] rounded-full bg-orange-100 h-1.5 flex items-center">
                <div
                    class="h-1.5 rounded-full bg-orange transition-all"
                    :style="{ width: Math.round((progressPercent / 100) * 175) + 'px' }"
                ></div>
            </div>
        </div>
        <div class="min-w-[60px]"></div>
    </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import { useQuizWizard } from '@/composables/useQuizWizard';

defineProps({
    step: { type: Number, required: true },
});

defineEmits(['back']);

const { progressPercent } = useQuizWizard();
</script>
